import React, { useState } from "react";
import LoadingButton from "../dumb/LoadingButton";
import DisplayError from "./DisplayError";
import TextInput from "./TextInput";
import PassInput from "./PassInput";
import useStatusThunk from "../../hook/useStatusThunk";
import { resetPassword, sendPasswordReset, verifyPasswordResetToken } from "../../redux/ducks/session";
import ResetPassword from "../smart/ResetPassword";

const LoginBlock = props => {

    const [userName, setUserName] = useState();
    const [password, setPassword] = useState();

    const [showReset, setShowReset] = useState(false);

    const onSubmit = e => {
        e.preventDefault();
        props.logIn(userName, password);
    }

    if (showReset) return <ResetPassword onSuccess={e => setShowReset(false)}/>;

    return (
        <form className="login" onSubmit={onSubmit}>
            <div className="group">
                <div className="label" name="userName">Username</div>
                <TextInput set={setUserName} v={userName} />
            </div>

            <div className="group">
                <div className="label" name="password">Password</div>
                <PassInput set={setPassword} v={password} />
            </div>

            <div className="group">
                <a className="link link--primary" href="/" onClick={e => { e.preventDefault(); setShowReset(true) }}>Forgot password</a>
            </div>

            <div className="group">
                <DisplayError error={props.error} />
            </div>

            <LoadingButton loading={props.loading} type="submit" className="button--primary login__button">
                Log In
            </LoadingButton>
        </form>
    )
}

export default LoginBlock;